import {
  Card,
  Heading,
  List,
  ListItem,
  StyledText,
} from '@walmart-web/livingdesign-components';
import React, {memo, useEffect, useMemo, useState} from 'react';
import JobOfferItem from './JobOfferItem';
import RegistrationConsentMedicalForm from '@livingdesign/pictograms/dist/svg/Health_Forms_&_Office/RegistrationConsentMedicalForm.svg';
import {useTranslation} from 'react-i18next';
import './offerSteps.scss';
import { useDrugScreenInfo } from 'pages/VirtualJobOffer/hooks/useDrugScreenInfo';
import { useVJOSteps } from 'pages/VirtualJobOffer/hooks/useVJOSteps';


const JobOfferSteps = () => {
  const {t} = useTranslation();
  const { drugScreenRequiredResponse } = useDrugScreenInfo();
  const { handleStepsUpdate } = useVJOSteps();
  const [offerSteps, setOfferSteps] = useState(t('vjoDashboard.pagesWithoutDS', {returnObjects: true}));

  useEffect(() => {
    setOfferSteps(handleStepsUpdate());
  },[drugScreenRequiredResponse, t]);


  return useMemo(()=>{
    return (<Card size='small' UNSAFE_className='dash_body_steps'>
      <>
        <StyledText
          leading={
            <img
              alt={t('vjoDashboard.jobOffer')}
              src={RegistrationConsentMedicalForm}
              className='job_offer_icon'
            />
          }
          size='small'
          children={
            <Heading
              size='small'
              weight={700}
              children={t('vjoDashboard.jobOffer')}
            />
          }
          UNSAFE_className='offer_header'
        />
        <List UNSAFE_className='offer_list_steps'>
          {Array.isArray(offerSteps) && offerSteps.map((offerStep, index) => {
            return (
              <ListItem key={index}>
                <JobOfferItem offerStep={offerStep} />
              </ListItem>
            );
          })}
        </List>
      </>
    </Card>
  )},[t, offerSteps, drugScreenRequiredResponse?.drugScreenRequired, drugScreenRequiredResponse?.fullSsnAvailable])
};

export default memo(JobOfferSteps);
